<template>
	<div class="prefe_sign_box preman" ref="minHeight">
		<!-- 内容 -->
		<el-collapse class="box_center" v-model="activeName" accordion>
			<el-collapse-item
				class="activity_item"
				:disabled="!loginStatus"
				v-for="(item, index) in actiAry"
				:name="item.AcType"
				:key="index"
				:data-id="item.AcType"
			>
				<template slot="title">
					<div class="title">
						<img :src="item.url" alt="" />
						<div class="cz">
							<div class="status">
								<span>进行中</span>
							</div>
							<div class="look_details">
								<span>查看详情</span>
							</div>
						</div>
					</div>
				</template>
				<!-- 展开后内容 -->
				<div class="content">
					<div class="every_day" v-if="item.AcType === 0">
						<div :class="[index < signDay ? 'checkedin' : '']" v-for="(item, index) in signAry" :key="index">
							<p>{{ item.data }}</p>
							<span>{{ item.name }}</span>
						</div>
					</div>
					<div class="sign_in" v-if="item.AcType === 0">
						<p>
							您已经连续签到<strong>{{ signInfo.SignCount }}</strong
							>天, 上次签到{{ signLastTime }}, 当前消费金额<strong>{{ signInfo.BetCount }}</strong
							>元
						</p>
						<template v-if="signcondition === 1">
							<el-button size="medium" type="primary" disabled>今日已签到</el-button>
						</template>
						<template v-else-if="signcondition === 2">
							<el-button size="medium" type="primary" @click="signBen">签到</el-button>
						</template>
						<template v-else-if="signcondition === 3">
							<el-button size="medium" type="primary" disabled>未达标</el-button>
						</template>
					</div>
					<div class="sign_in" v-else-if="item.AcType === 1">
						<p>
							您当前消费<strong>{{ betInfo.BetCount }}</strong
							>元, 可领取<strong>{{ betInfo.CashGift }}</strong
							>元
						</p>
						<diV class="preM_content_btnbox box_h">
							<template v-if="betInfo.bl">
								<el-button size="medium" type="primary" @click="getMoney">领取</el-button>
							</template>
							<template v-else>
								<el-button size="medium" type="info" disabled>已领取</el-button>
							</template>
						</diV>
					</div>
					<div class="sign_in" v-else-if="item.AcType === 2">
						<p>
							首充金额<strong>{{ regInfo.FirstRechargeMoney }}</strong
							>元, 可领取<strong>{{ regInfo.CashGift }}</strong
							>元
						</p>
						<diV class="preM_content_btnbox box_h">
							<!-- 未签到添加类名 has_not_sign -->
							<template v-if="regInfo.bl">
								<el-button size="medium" type="primary" @click="getGift">领取</el-button>
							</template>
							<template v-else>
								<el-button size="medium" type="info" disabled>不可领取</el-button>
							</template>
						</diV>
					</div>
					<div class="sign_in" v-else-if="item.AcType === 7">
						<p>
							当前等级<strong>{{ promotionAwardInfo.VipGrade }}</strong
							>&emsp;晋级奖励<strong>{{ promotionAwardInfo.CashGift }}</strong>
						</p>
						<diV class="preM_content_btnbox box_h">
							<!-- 未签到添加类名 has_not_sign -->
							<template v-if="promotionAwardInfo.bl">
								<el-button size="medium" type="primary" @click="getPromotionAward">领取</el-button>
							</template>
							<template v-else>
								<el-button size="medium" type="info" disabled>不可领取</el-button>
							</template>
						</diV>
					</div>
					<div class="sign_in" v-else-if="item.AcType === 8">
						<p>
							昨日投注：<strong>{{ dailyBonusInfo.YDayBetMoney }}</strong
							>&emsp;当前等级：<strong>{{ dailyBonusInfo.VipGrade }}</strong
							>&emsp;加奖比例：<strong>{{ dailyBonusInfo.DbRatio }}</strong
							>&emsp;可得加奖：<strong>{{ dailyBonusInfo.CashGift }}</strong>
						</p>
						<diV class="preM_content_btnbox box_h">
							<!-- 未签到添加类名 has_not_sign -->
							<template v-if="dailyBonusInfo.bl">
								<el-button size="medium" type="primary" @click="getDailyBonus">领取</el-button>
							</template>
							<template v-else>
								<el-button size="medium" type="info" disabled>不可领取</el-button>
							</template>
						</diV>
					</div>
					<div class="sign_in" v-else-if="item.AcType === 5">
						<p>
							您今日首充金额<strong>{{ topUpInfo.FirstRechargeMoney }}</strong
							>元, 可领取<strong>{{ topUpInfo.CashGift }}</strong
							>元
						</p>
						<template v-if="topUpInfo.bl">
							<el-button size="medium" type="primary" @click="getMoney">领取</el-button>
						</template>
						<template v-else>
							<el-button size="medium" type="primary" disabled>已领取</el-button>
						</template>
					</div>
					<div class="sign_in" v-else-if="item.AcType === 19">
						<div v-if="quickRechargeInfo.ReceiveStatus !== 1">
							<p>
								累积极速充值金额<strong>{{ quickRechargeInfo.RechargeAmount }}</strong
								>元, 可领取<strong>{{ quickRechargeInfo.BonusMoney }}</strong
								>元
							</p>
						</div>
						<div v-else>
							<p>今日已领取结束</p>
						</div>
						<diV class="preM_content_btnbox box_h">
							<!-- 未签到添加类名 has_not_sign -->
							<el-button
								size="medium"
								type="primary"
								:disabled="quickRechargeInfo.ReceiveStatus !== 2 || disableBtn"
								@click="getQuickRechargeGift"
							>
								<div>{{ showBtnText }}</div>
							</el-button>
						</diV>
					</div>
					<!-- 活动说明详情--后端返回 -->
					<div class="item_text" v-html="item.Description"></div>
				</div>
			</el-collapse-item>
		</el-collapse>
	</div>
</template>
<script>
// 引用axios封装文件
import { postAjax } from "../../util/ajax.js";
// collapse 展开折叠
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";
import { SysKey } from "../../util/sysconfig";

export default {
	computed: {
		loginStatus() {
			return this.$store.state.loginStatus;
		},
		showBtnText() {
			switch (this.quickRechargeInfo.ReceiveStatus) {
				case 0:
					return "不可领取";
				case 1:
					return "已领取";
				case 2:
					return "可领取";
			}
		},
	},
	components: {
		CollapseTransition,
	},
	data() {
		return {
			url: SysKey("ImgServerUrl").SysValue, //图片地址
			activeName: "100",
			actiAry: [], //活动数据
			signAry: [
				{ data: "第一天", name: "未签到" },
				{ data: "第二天", name: "未签到" },
				{ data: "第三天", name: "未签到" },
				{ data: "第四天", name: "未签到" },
				{ data: "第五天", name: "未签到" },
				{ data: "第六天", name: "未签到" },
				{ data: "第七天", name: "未签到" },
			], //签到数组
			signInfo: {}, //签到信息
			signDay: 0, //每日签到天数
			signLastTime: "无",
			signcondition: 1, //是否满足签到条件
			betInfo: {}, //投注信息
			regInfo: {}, //首充信息
			topUpInfo: {}, //充值大放送信息
			promotionAwardInfo: {}, //晋级奖励信息
			dailyBonusInfo: {}, //每日加奖信息
			quickRechargeInfo: {}, //極速充值信息
			disableBtn: false,
		};
	},
	methods: {
		// 获取活动信息
		getActive() {
			const loading = this.$loading({
				lock: true,
				text: "Loading",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.7)",
			});

			let url = "api/Activity/GetActList";
			postAjax(url).then(data => {
				loading.close();
				if (data.IsSucess) {
					this.actiAry = data.Data.map((item, index) => {
						let newitem = item;
						newitem.url = this.url + item.ImgUrl;
						if (item.AcType === 0) {
							this.getEveryDayInfo();
						} else if (item.AcType === 1) {
							this.getBetInfo();
						} else if (item.AcType === 2) {
							this.getRegInfo();
						} else if (item.AcType === 3) {
						} else if (item.AcType === 5) {
							this.gettopUpInfo();
						} else if (item.AcType === 7) {
							this.getPromotionAwardInfo();
						} else if (item.AcType === 8) {
							this.getDailyBonusInfo();
						} else if (item.AcType == 19) {
							this.getQuickRechargeInfo();
						}
						return newitem;
					});
					this.scrollToActiveItem();
				}
			});
		},
		//获取每日签到信息
		getEveryDayInfo() {
			if (!localStorage.getItem("Authorization")) {
				return false;
			}

			let url = "api/Activity/GetSignInfo";
			postAjax(url, {})
				.then(data => {
					if (data.IsSucess) {
						this.signInfo = data.Data;
						this.signDay = data.Data.SignCount;
						// 判断是否有签到时间
						if (data.Data.LastSignTime == null) {
							this.signLastTime = "无";
						} else {
							this.signLastTime = data.Data.LastSignTime;
						}
						// 判断是今天是否可以签到签到条件
						if (data.Data.bl === false) {
							if (data.Data.BetCount >= data.Data.Amount) {
								this.signcondition = 2;
							} else {
								this.signcondition = 3;
							}
						} else if (data.Data.bl) {
							this.signcondition = 1;
						}
					}
				})
				.then(() => {
					let index = 0;
					this.signAry.forEach(item => {
						index++;
						if (index <= this.signInfo.SignCount) {
							item.name = "已签到";
						}
					});
				});
		},
		// 获取礼金信息
		getBetInfo() {
			if (!localStorage.getItem("Authorization")) {
				return false;
			}

			let url = "api/Activity/GetBetInfo";
			postAjax(url).then(data => {
				if (data.IsSucess) {
					this.betInfo = data.Data;
				}
			});
		},
		// 获取快速充值信息
		getQuickRechargeInfo() {
			if (!localStorage.getItem("Authorization")) {
				return false;
			}

			let url = "api/Activity/GetQuickRechargeBonusInfo";
			postAjax(url).then(data => {
				if (data.IsSucess == true) {
					this.quickRechargeInfo = data.Data;
				}
			});
		},
		getQuickRechargeGift() {
			let url = "api/Activity/ReceiveQuickRechargeBonus";
			let t = this.quickRechargeInfo.Time;
			this.disableBtn = true;
			postAjax(url, { Time: t }).then(data => {
				if (data.IsSucess) {
					this.openSuccess(data.Message);
					this.quickRechargeInfo.ReceiveStatus = 1;
				} else {
					this.openMessAge(data.Message);
					this.quickRechargeInfo = {
						BonusMoney: 0,
						ReceiveStatus: 0,
						RechargeAmount: 0,
					};
				}
				this.disableBtn = false;
			});
		},
		// 获取首充信息
		getRegInfo() {
			if (!localStorage.getItem("Authorization")) {
				return false;
			}
			let url = "api/Activity/GetFirstRechargeInfo";
			postAjax(url).then(data => {
				this.regInfo = data.Data;
			});
		},
		//获取充值大放送信息
		gettopUpInfo() {
			let url = "api/Activity/GetRechargeInfo";
			postAjax(url).then(data => {
				if (data.IsSucess) {
					this.topUpInfo = data.Data;
				}
			});
		},
		// 签到
		signBen() {
			let url = "api/Activity/Sign";
			postAjax(url).then(data => {
				if (data.IsSucess) {
					this.openSuccess("签到成功");
				} else {
					this.openMessAge(data.Message);
				}
			});
		},
		//成功提示
		openSuccess(data) {
			this.$message({
				message: data,
				type: "success",
				duration: 2000,
				onClose: () => {
					this.getSignbtn();
				},
			});
		},
		// 失败提示
		openMessAge(data) {
			this.$message.error(data);
		},
		// 领取
		getMoney() {
			let url = "api/Activity/GetGift";
			postAjax(url).then(data => {
				if (data.IsSucess) {
					this.openSuccess(data.Message);
				} else {
					this.openMessAge(data.Message);
				}
			});
		},
		judRouter() {
			if (this.$route.query.ids) {
				this.activeName = Number(this.$route.query.ids);
			}
		},
		scrollToActiveItem() {
			this.$nextTick(() => {
				let el = document.querySelector("[data-id='" + this.activeName + "']");
				if (el) {
					window.scrollTo({
						top: el.offsetTop,
						behavior: "smooth",
					});
				}
			});
		},
		// 领取
		getGift() {
			let url = "api/Activity/GetFirstRechargeGift";
			postAjax(url).then(data => {
				if (data.IsSucess) {
					this.openSuccess(data.Message);
				} else {
					this.openMessAge(data.Message);
				}
			});
		},
		//晋级奖励信息获取
		getPromotionAwardInfo() {
			if (!localStorage.getItem("Authorization")) {
				return false;
			}

			let url = "/api/Activity/GetPromotionAwardInfo";
			postAjax(url).then(data => {
				if (data.IsSucess) {
					this.promotionAwardInfo = data.Data;
				}
			});
		},
		//晋级奖励领取
		getPromotionAward() {
			let url = "/api/Activity/GetPromotionAwardGift";
			postAjax(url).then(data => {
				if (data.IsSucess) {
					this.$message.success(data.Message);
					this.getPromotionAwardInfo();
				} else {
					this.openMessAge(data.Message);
				}
			});
		},
		//没日加奖信息获取
		getDailyBonusInfo() {
			if (!localStorage.getItem("Authorization")) {
				return false;
			}

			let url = "/api/Activity/GetDailyBonusInfo";
			postAjax(url).then(data => {
				if (data.IsSucess) {
					this.dailyBonusInfo = data.Data;
				}
			});
		},
		//加奖领取
		getDailyBonus() {
			let url = "/api/Activity/GetDailyBonusInfoGift";
			postAjax(url).then(data => {
				if (data.IsSucess) {
					this.$message.success(data.Message);
					this.getDailyBonusInfo();
				} else {
					this.openMessAge(data.Message);
				}
			});
		},
	},
	created() {
		this.judRouter();
		this.getActive();
	},
};
</script>
<style>
.preman .prefe_sign_box .el-collapse-item__header {
	min-height: 227px !important;
}

.preman .el-collapse-item__header {
	background: none;
}

.preman .el-collapse {
	border: none;
}

.preman .el-collapse-item__header i {
	display: none;
}

.preman .el-collapse-item__header {
	height: auto;
}

.preman .el-collapse-item__header {
	border: 0;
}

/* 展开后内容容器 */
.preman .el-collapse-item__wrap {
	border-radius: 15px 15px 15px 15px !important;
	border: none;
	background-color: #fff;
}

.preman .el-collapse-item__content {
	padding-bottom: 0;
}
</style>
<style lang="less" scoped>
.prefe_sign_box {
	width: 100%;
	background: url("~@/static/img/bg.jpg") fixed no-repeat;
	padding-bottom: 50px;

	.box_center {
		.activity_item {
			width: 1200px;
			height: auto;
			.title {
				position: relative;
				width: 100%;
				height: 227px;
				margin-top: 20px;
				.cz {
					position: absolute;
					width: 200px;
					height: 100%;
					right: 0;

					.status {
						width: 80px;
						height: 20px;
						background: #84397b url(../../static/img/preMain/icon-underway.png) no-repeat 10px center;
						border-radius: 10px 10px 10px 10px;
						line-height: 20px;
						text-align: center;
						margin-top: 45px;
						margin-left: 60px;
						padding-left: 20px;
						cursor: pointer;

						span {
							color: #fff !important;
							font-size: 12px !important;
						}
					}

					.look_details {
						width: 100px;
						height: 20px;
						background: #d86556 url(../../static/img/preMain/icon-detail.png) no-repeat 80px center;
						border-radius: 10px 10px 10px 10px;
						line-height: 20px !important;
						text-align: center;
						margin-top: 127px;
						margin-left: 60px;
						cursor: pointer;

						span {
							color: #fff !important;
							font-size: 12px !important;
						}
					}
				}

				img {
					width: 100%;
					height: 100%;
					position: absolute;
				}
				i {
					display: none;
				}
			}

			.content {
				width: 100%;

				.every_day {
					display: flex;
					justify-content: space-around;
					padding: 15px 0 0;

					div {
						width: 148px;
						height: 50px;
						padding: 5px 0;
						border: 1px solid #0e78c7;
						color: white;
						border-radius: 5px;
						cursor: pointer;

						p {
							font-size: 16px;
							font-stretch: normal;
							line-height: 20px;
							letter-spacing: 2px;
							color: white;
							text-align: center;
						}

						span {
							display: inline-block;
							width: 100%;

							font-size: 14px;
							font-stretch: normal;
							line-height: 14px;
							letter-spacing: 1px;
							color: white;
							text-align: center;
						}
					}

					.checkedin {
						background-color: #0e78c7 !important;
					}
				}

				.sign_in {
					width: 1160px;
					padding-top: 25px;
					background-color: #fff;
					border-radius: 5px;
					text-align: center;

					p {
						font-size: 16px;
						font-weight: normal;
						font-stretch: normal;
						line-height: 16px;
						letter-spacing: 2px;
						color: #0e78c7;

						strong {
							color: #0e78c7;
						}
					}

					button {
						margin: 22px auto 0;
					}
				}

				.item_text {
					width: 100%;
					margin: 0 auto;
					background-color: #3d3d3d;
				}
			}
		}
	}
}

.item_text /deep/ div:first-child {
	background: #fff !important;
}
.item_text /deep/ div .app_act_title_panel {
	background-image: none !important;
	background-color: #0e78c7 !important;
	color: white;
}

.item_text /deep/ p,
span {
	font-size: 16px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 2px;
	color: #000000;
}

.item_text /deep/ span {
	font-size: 16px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 24px;
	letter-spacing: 2px;
	color: #000;
}

.item_text /deep/ table td {
	height: 40px;
}

@-webkit-keyframes preHot {
	from {
		top: -16px;
	}
	to {
		top: -18px;
	}
}

@keyframes preHot {
	from {
		top: -16px;
	}
	to {
		top: -18px;
	}
}

.sign_top_banner {
	padding-top: 10px;
}

.sign_top_banner {
	margin-bottom: 10px;
}

.sign_top_banner > .sign_banner_pic {
	width: 100%;
	height: 120px;
	display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/prefectActive/preMain.vue